import { render, staticRenderFns } from "./informacionBasica.vue?vue&type=template&id=5b921197"
import script from "./informacionBasica.vue?vue&type=script&lang=js"
export * from "./informacionBasica.vue?vue&type=script&lang=js"
import style0 from "./informacionBasica.vue?vue&type=style&index=0&id=5b921197&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports